import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import client from '../api/client';

export default function ConstituencyResults() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    client.get(`/results/constituency/${id}`).then(res => {
      setData(res.data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [id]);

  if (loading) return <div className="loading">Loading...</div>;
  if (!data) return <div className="dashboard-container"><p>Constituency not found.</p><Link to="/results">Back</Link></div>;

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>{data.constituency.name} Constituency Results</h1>
        <Link to="/results" className="btn-secondary">Back to Results</Link>
      </div>

      <div className="card">
        <p>Total Votes in Constituency: <strong>{data.total_votes}</strong></p>
      </div>

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Rank</th>
              <th>Candidate</th>
              <th>Party</th>
              <th>Votes</th>
            </tr>
          </thead>
          <tbody>
            {data.candidates.map((c, idx) => (
              <tr key={c.id}>
                <td>#{idx + 1}</td>
                <td>{c.candidate_name}</td>
                <td>{c.party_name}</td>
                <td>{c.vote_count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
